// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //API_HOST: 'http://localhost:9191/bmw/api',
  //API_HOST: 'https://qa.api.shopbrandnew.com',
  // API_ASSETS_HOST: 'http://localhost',
  API_HOST: 'https://api.brandnew.vaageesa.com',
  API_ASSETS_HOST: 'https://assets.brandnew.vaageesa.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
